import { render, staticRenderFns } from "./lettersSystem.vue?vue&type=template&id=8e553496&scoped=true&"
import script from "./lettersSystem.vue?vue&type=script&lang=js&"
export * from "./lettersSystem.vue?vue&type=script&lang=js&"
import style0 from "./lettersSystem.vue?vue&type=style&index=0&id=8e553496&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e553496",
  null
  
)

export default component.exports